/**
 * Project-scoped meetings settings state.
 * Indexed by `projectId` so each project keeps its own settings and
 * load status.
 */

export const timeSlotOptions = [
    { key: 1, value: 5, text: '5 mins' },
    { key: 2, value: 15, text: '15 mins' },
    { key: 3, value: 30, text: '30 mins' },
    { key: 3, value: 45, text: '45 mins' },
    { key: 4, value: 60, text: '1 hr' },
    { key: 4, value: 90, text: '90 mins' },
    { key: 4, value: 120, text: '2 hr' },
];

export const getProjectMeetingsDefaults = () => ({
    settingsLoading: false,
    slotDuration: timeSlotOptions[1].value,
    meetReminderTime: [{ unit: 'minute', value: 5 }],
    meetingsAllowedCount: 0,
    timeRanges: [],
    locations: [],
    defaultData: { attendees: [], organiser: [] },
    noOfAllowedParticipantPerMeeting: 5,
    disableEmailNotification: false,
    disableDailyDigestEmail: true,
    disableSummaryEmail: false,
    disablePhysicalMeeting: false,
    disableOnlineMeeting: false,
    enableConfirmationEmail: false,
    confirmationCutOffTime: null,
    disableConfirmationCutOffTime: true,
    networkingPageId: '',
    bccEmail: null,
});

const PROJECT_MEETINGS_DEFAULTS = getProjectMeetingsDefaults();
const PROJECT_MEETINGS_LOADING_DEFAULTS = {
    ...PROJECT_MEETINGS_DEFAULTS,
    settingsLoading: true,
};
const meetingsProjectSelectorCache = new Map();

export const actions = {
    setMeetingsState: ({ projectId, patch }) => ({
        type: 'MEETINGS_SET_STATE',
        payload: { projectId, patch },
    }),
    setSettingsLoading: ({ projectId, loading }) => ({
        type: 'MEETINGS_SET_SETTINGS_LOADING',
        payload: { projectId, loading },
    }),
};

export const selectMeetingsProject = (state, projectId) => {
    if (!projectId) return PROJECT_MEETINGS_DEFAULTS;
    const stored = state?.meetings?.byProject?.[projectId];
    if (!stored) {
        meetingsProjectSelectorCache.delete(projectId);
        return PROJECT_MEETINGS_LOADING_DEFAULTS;
    }

    const cached = meetingsProjectSelectorCache.get(projectId);
    if (cached?.storedRef === stored) return cached.value;

    const value = {
        ...PROJECT_MEETINGS_DEFAULTS,
        ...stored,
    };
    meetingsProjectSelectorCache.set(projectId, {
        storedRef: stored,
        value,
    });
    return value;
};

export const selectTimeSlotOptions = (state) =>
    state?.meetings?.timeSlotOptions || timeSlotOptions;
